import { KeyValuePair, RenewableExtraFieldKeys } from '../enums';
import { Dictionary } from '../models';

const getExtraField = (extraFields: KeyValuePair[], fieldKey: string): KeyValuePair => {
    return (
        extraFields.find(_ => _.key.toLocaleLowerCase() === fieldKey.toLocaleLowerCase()) ||
        <KeyValuePair>{
            key: fieldKey,
            value: null
        }
    );
};

export const getExtraFieldValue = (extraFields: Array<KeyValuePair>, fieldKey: string): string => {
    const extraField = getExtraField(extraFields, fieldKey);

    return extraField.key ? extraField.value : '';
};

export const resolveSystemType = (extraFields: Dictionary<string>): string =>
    extraFields?.[RenewableExtraFieldKeys.ConfirmedSystemType] ||
    extraFields?.[RenewableExtraFieldKeys.RenewableSystemType];
